import React from 'react';

const Check = () => {
  return (
    <svg width="20.251" height="14.627" viewBox="0 0 20.251 14.627">
      <path id="Icon_feather-check" data-name="Icon feather-check" d="M22.009,9,11,20.006,6,15" transform="translate(-3.879 -6.879)" fill="none" stroke="#ec1c24" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
    </svg>
  );
};

export default Check;